import { memo, useState } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}

function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}

function findBySid(sub, sid) {
  return sub.find((s) => s.sid === sid);
}

function fmtAmt(n) {
  const x = Number(n) || 0;
  if (x >= 100000) return `${x / 100000}L`;
  if (x >= 1000) return `${x / 1000}K`;
  return String(x);
}

function bookOf(exposures, name, sid) {
  return roundBook(exposures?.[`sid:${sid}`] ?? exposures?.[name] ?? 0);
}

function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

// Player A sids 11-19, Player B sids 21-29
const BET_TYPES = [
  { label: 'Winner',          sidA: 11, sidB: 21, max: 300000 },
  { label: 'One Pair',        sidA: 12, sidB: 22, max: 25000 },
  { label: 'Two Pair',        sidA: 13, sidB: 23, max: 25000 },
  { label: 'Three of a Kind', sidA: 14, sidB: 24, max: 5000 },
  { label: 'Straight',        sidA: 15, sidB: 25, max: 5000 },
  { label: 'Flush',           sidA: 16, sidB: 26, max: 5000 },
  { label: 'Full House',      sidA: 17, sidB: 27, max: 5000 },
  { label: 'Four of a Kind',  sidA: 18, sidB: 28, max: 2000 },
  { label: 'Straight Flush',  sidA: 19, sidB: 29, max: 1000 },
];

const DESKTOP_GROUPS = [[0, 1, 2], [3, 4, 5], [6, 7, 8]];

// range collapse; wrap=true => desktop ml-1 float-right wrapper
function Range({ rangeId, min, max, wrap }) {
  const [open, setOpen] = useState(false);
  const info = (
    <>
      <i
        data-toggle="collapse"
        data-target={`#${rangeId}`}
        aria-expanded={open ? 'true' : 'false'}
        className={`fas fa-info-circle float-right${open ? '' : ' collapsed'}`}
        onClick={() => setOpen((o) => !o)}
      ></i>
      {' '}
      <div id={rangeId} className={`collapse icon-range${open ? ' show' : ''}`}>
        {'\n                      R:'}
        <span>{fmtAmt(min ?? 100)}</span>
        -
        <span>{fmtAmt(max ?? 0)}</span>
      </div>
    </>
  );
  return wrap ? <div className="ml-1 float-right">{info}</div> : info;
}

const BetTablePoker20 = memo(function BetTablePoker20({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});

  const items = BET_TYPES.map(({ label, sidA, sidB, max }) => ({
    label, max,
    itemA: findBySid(sub, sidA),
    itemB: findBySid(sub, sidB),
  }));

  const backCell = (item, key) => {
    const book = bookOf(exposures, item?.nat, item?.sid);
    return (
      <div
        key={key}
        // With a liability, a locked cell pins its padlock to the TOP (style.css
        // `.suspended.lock-top:before`) so the figure stays readable.
        className={`back casino-bl-box-item${book ? ' lock-top' : ''}${suspCls(item)}`}
        onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
      >
        <span className="casino-box-odd">{item?.b || 0}</span>
        {' '}
        <span className={`casino-book ${bookCls(book)}`}>{fmtBook(book)}</span>
      </div>
    );
  };

  // desktop side: which='left'(A)/'right'(B), offset (0 => range1-9, 9 => range10-18)
  const side = (which, offset) => (
    <div className={`poker20${which}`}>
      {DESKTOP_GROUPS.map((group, gi) => (
        <div key={gi} className={gi > 0 ? 'mt-1' : ''}>
          <div className="casino-bl-box casino-bl-box-title">
            {group.map((idx) => (
              <div key={idx} className="casino-bl-box-item">
                <span>{items[idx].label}</span>
                {' '}
                <Range rangeId={`range${idx + 1 + offset}`} min={100} max={items[idx].max} wrap />
              </div>
            ))}
          </div>
          <div className="casino-bl-box">
            {group.map((idx) => backCell(which === 'left' ? items[idx].itemA : items[idx].itemB, idx))}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <>
      {/* Desktop */}
      <div className="poker20casino-container d-none-small">
        {side('left', 0)}
        <div className="poker20center"></div>
        {side('right', 9)}
      </div>

      {/* Mobile */}
      <div className="poker20casino-container d-none-big">
        <div className="casino-bl-box casino-bl-box-title">
          <div className="casino-bl-box-item"></div>
          <div className="casino-bl-box-item playera">Player A</div>
          <div className="casino-bl-box-item playerb">Player B</div>
        </div>
        {items.map(({ label, itemA, itemB, max }, idx) => (
          <div key={idx} className="casino-bl-box">
            <div className="casino-bl-box-item casino-odds-name">
              <span>{label}</span>
              {' '}
              <Range rangeId={`range${idx + 1}`} min={100} max={max} />
            </div>
            {backCell(itemA, 'a')}
            {backCell(itemB, 'b')}
          </div>
        ))}
      </div>
    </>
  );
});

export default BetTablePoker20;
